export const BUDGET_LINE_COMMENT_TYPE = "comment";

export const isBudgetCommentLine = (line) => line?.type === BUDGET_LINE_COMMENT_TYPE;

export const getBudgetLineAmount = (line) => {
	if (isBudgetCommentLine(line)) {
		return 0;
	}

	const quantity = Number(line?.quantity) || 0;
	const cost = Number(line?.cost) || 0;
	return quantity * cost;
};

export const getBudgetLinesTotal = (budgetLines = []) =>
	(budgetLines || []).reduce((acc, line) => acc + getBudgetLineAmount(line), 0);

export const getBudgetContentLines = (budgetLines = []) =>
	(budgetLines || []).filter((line) => !isBudgetCommentLine(line));

export const getBudgetCommentText = (line) =>
	(line?.comment || line?.description || line?.name || "").trim();
